import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { COLOR_SUCCESS } from "../../../constants/theme";
import {
  AssignmentType,
  TaskAssignmentNotification,
} from "../../../cores/notifications/interfaces/api/get-notifications";
import "./TaskAssignmentNotificationItem.scss";

interface Props {
  notification: TaskAssignmentNotification;
  variant?: "dropdown" | "page";
  isDarkMode?: boolean;
}

export default function TaskAssignmentNotificationItem({
  notification,
  variant = "dropdown",
  isDarkMode = false,
}: Props) {
  const intl = useIntl();

  const taskType = useMemo(() => {
    switch (notification.type) {
      case AssignmentType.ACTIVITY:
        return intl.formatMessage({ id: "app.notifications.taskType.activity" });
      case AssignmentType.CRM:
        return intl.formatMessage({ id: "app.notifications.taskType.crm" });
      case AssignmentType.TASK:
        return intl.formatMessage({ id: "app.notifications.taskType.task" });
      default:
        return "";
    }
  }, [notification.type, intl]);

  if (variant === "page") {
    return (
      <div
        className={cn("task-assignment-notification-page", {
          "task-assignment-notification-page--dark": isDarkMode,
        })}
      >
        <div className="task-assignment-notification-page__icon-wrap">
          <FontAwesomeIcon
            icon={["fas", "tasks"]}
            size="lg"
            color={COLOR_SUCCESS}
          />
        </div>
        <div className="task-assignment-notification-page__body">
          <p className="task-assignment-notification-page__eyebrow">
            {intl.formatMessage({ id: "app.notifications.kind.taskAssignment" })}
          </p>
          <p className="task-assignment-notification-page__title">
            {intl.formatMessage(
              { id: "app.notifications.taskAssignedTitle" },
              { type: taskType }
            )}
          </p>
          <p className="task-assignment-notification-page__detail">
            {notification.title}
          </p>
          <span className="task-assignment-notification-page__chip">{taskType}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center border-bottom mb-1">
      <FontAwesomeIcon
        icon={["fas", "tasks"]}
        className="mr-2"
        size="2x"
        color={COLOR_SUCCESS}
      />
      <div className="d-flex flex-column overflow-hidden">
        <span className="capitalize">
          Te asignaron una nueva {taskType}
        </span>
        <span className="text-truncate text-muted text-wrap">
          {notification.title}
        </span>
      </div>
    </div>
  );
}
